import { ReactNode } from "react";
import { useIntl, IntlFormatters } from "react-intl";

export type TFunction = IntlFormatters<ReactNode>["formatMessage"];

export interface UseTranslationsReturn {
  t: TFunction;
}

export const useTranslations = (): UseTranslationsReturn => {
  const intl = useIntl();

  return { t: intl.formatMessage };
};
